import { AppBar, Backdrop, Box, Button, ButtonGroup, CircularProgress, Modal, Paper, TextareaAutosize, Toolbar, Tooltip, Typography } from "@mui/material";
import { LoadState } from "../../../../redux/common";
import { useAppDispatch } from "../../../../app/hooks";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { RootState } from "../../../../app/store";
import { executeUserInvite } from "../../../../redux/user/userInviteSlice";

export interface ModalInviteUserProps {
    open: boolean;
    close: () => void;
}

const ModalInviteUser = (props: ModalInviteUserProps) => {
    const dispatch = useAppDispatch();
    const userInvite = useSelector((state: RootState) => state.userInvite);
    
    const confirm = () => {
        const text = document.getElementById("invite-users");
        if(text == null || (text as HTMLTextAreaElement).value.trim().length == 0) {
            return;
        }
        dispatch(executeUserInvite({users: (document.getElementById("invite-users") as HTMLTextAreaElement).value}));
    };

    const elToolbar = <AppBar position="static" color={"primary"} sx={{ top: "auto", bottom: 0 }}>
        <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}> Convidar usuários </Typography>
            <Box sx={{ flexGrow: 1 }} />
                <ButtonGroup variant="contained" color="secondary">
                    <Tooltip title="Fechar" >
                        <Button key="close" onClick={(/* event */) => { props.close(); }}><CloseIcon /></Button>
                    </Tooltip>
                </ButtonGroup>
        </Toolbar>
    </AppBar>;

    const sample = "john.doe@gmail.com, jane.doe@gmail.com\nsteve.doe@gmail.com";
    return <Modal open={props.open} onClose={() => {/* do nothing */}} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Paper sx={{ width: "90%", m: "5%", minWidth: "300px" }} elevation={3}>
            {elToolbar}
            <Box sx={{width: "100%", p: 2}}>
                <Typography variant="subtitle1" component="div" sx={{width: "100%", mb: 1}}> Insira um email ou uma lista separada por virgulas ou multiplas linhas </Typography>
                <TextareaAutosize
                    id='invite-users'
                    minRows={10}
                    maxRows={10}
                    aria-label="Convidar novos usuários"
                    placeholder={sample}
                    style={{width: "100%"}} />
            </Box>
            <Box width="100%" sx={{textAlign: "center"}}>
                <Button variant='contained' sx={{m:1}} onClick={() => confirm()}>Confirmar</Button>
                <Button variant='contained' sx={{m:1}} color='error' onClick={() => props.close()}>Cancelar</Button>
            </Box>
            <Backdrop open={userInvite.state.state == LoadState.Loading} sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </Paper>
    </Modal>;
};

export default ModalInviteUser;